<script setup lang="ts">
defineProps({ blok: Object })
</script>

<template>
    <section class="pb-20">
        <UiContainer>
            <div class="grid grid-cols-2 items-center gap-x-12 max-[769px]:grid-cols-1 max-[769px]:gap-x-0 max-[769px]:gap-y-10">
                <header class="global-text">
                    <StoryblokRichText :doc="blok?.header" />
                </header>
                <div>
                    <img
                        v-motion-slide-visible-once-bottom
                        :src="blok?.image.filename"
                        :alt="blok?.image.alt"
                        class="max-w-none max-[769px]:max-w-full"
                    >
                </div>
            </div>
        </UiContainer>
        <UiContainer max-width="max-w-3xl">
            <div class="mt-20 global-text">
                <StoryblokRichText :doc="blok?.description" />
            </div>
        </UiContainer>
    </section>
</template>
